<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <dogGroomingBanner-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import dogGroomingBannerComponent from '../dogGrooming/dogGroomingBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'bookingComponent',
  components: {
    headerComponent,
    dogGroomingBannerComponent,
    footerComponent,
  },
};
</script>
